import { useMemo } from "react";
import { GridColDef } from "@mui/x-data-grid";
import Link from "@mui/material/Link";
import { useNavigate } from "react-router-dom";
import { VendorProductRow } from "../types";
import { abbreviateNumber } from "../../../../../utils/numberUtils";

export const useGetVendorProductColumns = () => {
  const navigate = useNavigate();

  const columns = useMemo<GridColDef<VendorProductRow[][number]>[]>(() => {
    return [
      {
        field: "productName",
        headerName: "Product Name",
        flex: 1,
        renderCell: (params) => {
          const productLocation = "/catalog/product/product/" + params.id;

          return (
            <Link
              href={productLocation}
              underline="none"
              onClick={(e) => {
                e.preventDefault();
                navigate(productLocation);
              }}
            >
              {params.value}
            </Link>
          );
        },
      },
      {
        field: "numberOfCompanies",
        headerName: "Number Of Companies",
        flex: 1,
        renderCell: (params) => {
          return abbreviateNumber(params.row.numberOfCompanies);
        },
      },
    ];
  }, [navigate]);

  return {
    columns,
  };
};
